import React, { useEffect } from 'react';

export function ScholarMetadata({ doc }) {
  useEffect(() => {
    const managedSelector = 'meta[data-scholar-metadata="1"]';
    document.querySelectorAll(managedSelector).forEach((el) => el.parentNode?.removeChild(el));

    const oldScript = document.getElementById('schema-json-ld');
    if (oldScript) oldScript.parentNode?.removeChild(oldScript);

    if (!doc) return;

    const setMeta = (key, content, attribute = 'name') => {
      const value = String(content || '').trim();
      if (!value) return;
      const el = document.createElement('meta');
      el.setAttribute('data-scholar-metadata', '1');
      el.setAttribute(attribute, key);
      el.setAttribute('content', value);
      document.head.appendChild(el);
    };

    const title = String(doc.title || '').trim();
    const author = String(doc.author || 'RDA Advocacia').trim();
    const year = String(doc.year || '').trim();
    const pdfUrl = String(doc.mirror_url || '').trim();

    if (title) setMeta('citation_title', title);
    if (author) setMeta('citation_author', author);
    if (year) setMeta('citation_publication_date', `${year}/01/01`);
    if (pdfUrl) setMeta('citation_pdf_url', pdfUrl);
    setMeta('citation_language', 'pt');

    setMeta('og:title', title, 'property');
    setMeta('og:type', 'article', 'property');
    setMeta('og:url', window.location.href, 'property');

    const schemaType = String(doc.type || '') === 'legislation' ? 'Legislation' : 'ScholarlyArticle';
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': schemaType,
      headline: title || undefined,
      author: author
        ? {
            '@type': 'Person',
            name: author,
          }
        : undefined,
      datePublished: year || undefined,
      url: window.location.href,
      downloadUrl: pdfUrl || undefined,
      publisher: {
        '@type': 'Organization',
        name: 'Portal Jurídico RDA',
      },
      inLanguage: 'pt-BR',
    };

    const script = document.createElement('script');
    script.id = 'schema-json-ld';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    if (title) document.title = title;
  }, [doc]);

  return null;
}